import { useEffect, useRef } from 'react';

export default function useClickOutside<T>(action, shouldClose) {
  const ref = useRef<T>(null);

  const handleClick = (event) => {
    // @ts-ignore
    if (ref.current && !ref.current.contains(event.target)) {
      action(event);
    }
  };

  useEffect(() => {
    if (shouldClose) {
      document.addEventListener('click', handleClick, true);
    }

    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, [shouldClose]);

  return ref;
}
